import React, { useEffect, useState } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function Home() {
    const [epapers, setEpapers] = useState([]);
    const [ads, setAds] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeCategory, setActiveCategory] = useState("All");

    const categories = ["All", "Main Edition", "District Edition", "Sunday Magazines"];

    const navigate = useNavigate();
    // API_BASE removed completely

    const FILE_BASE = process.env.REACT_APP_API_URL + "/uploads"; // 👈 important

    useEffect(() => {
        Promise.all([fetchEpapers(), fetchAds()]).finally(() => setLoading(false));
    }, []);

    const fetchEpapers = async () => {
        try {
            const res = await API.get("/epapers/all");
            setEpapers(res.data);
        } catch (error) {
            console.error("Error fetching epapers:", error);
        }
    };

    const fetchAds = async () => {
        try {
            const res = await API.get("/ads/active");
            setAds(res.data);
        } catch (error) {
            console.error("Error fetching ads:", error);
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    return (
        <div className="bg-gray-50 pb-16">
            <div className="container mx-auto px-4 mt-6">
                <div className="flex flex-col lg:flex-row gap-8">

                    {/* Epaper Section - 75% width on large screens */}
                    <div className="w-full lg:w-3/4">
                        {/* Category Filter Tabs */}
                        <div className="flex border-b border-gray-200 mb-6 overflow-x-auto scrollbar-hide">
                            {categories.map((category) => (
                                <button
                                    key={category}
                                    onClick={() => setActiveCategory(category)}
                                    className={`py-3 px-6 text-sm font-bold whitespace-nowrap transition-all duration-200 ${activeCategory === category
                                        ? "border-b-2 border-red-600 text-red-600"
                                        : "text-gray-500 hover:text-gray-800 hover:bg-gray-50 border-b-2 border-transparent"
                                        }`}
                                >
                                    {category}
                                </button>
                            ))}
                        </div>

                        {epapers.filter(paper => activeCategory === "All" || paper.edition === activeCategory).length === 0 ? (
                            <div className="text-center text-gray-500 mt-10 p-10 bg-white border border-gray-100 rounded shadow-sm">
                                No epapers available in this category.
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                                {epapers.filter(paper => activeCategory === "All" || paper.edition === activeCategory).map((paper) => (
                                    <div
                                        key={paper.id}
                                        onClick={() => navigate(`/viewer/${paper.id}`)}
                                        className="bg-white rounded overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer border border-gray-200 group flex flex-col h-full"
                                    >
                                        {/* ... PDF Preview ... */}
                                        <div className="relative bg-gray-100 flex justify-center items-center overflow-hidden h-72 border-b">
                                            <Document
                                                // file={`${API_BASE}/epapers/${paper.pdf_path}`}
                                                file={`${window.location.origin}${process.env.REACT_APP_API_URL}/epapers/download/${paper.id}`}
                                                loading={
                                                    <div className="animate-pulse flex p-4 w-full">
                                                        <div className="h-48 w-full bg-slate-200 rounded"></div>
                                                    </div>
                                                }
                                                className="scale-90 group-hover:scale-100 transition-transform duration-500 origin-top"
                                            >
                                                <Page
                                                    pageNumber={1}
                                                    width={280}
                                                    renderTextLayer={false}
                                                    renderAnnotationLayer={false}
                                                />
                                            </Document>

                                            <div className="absolute top-3 left-3 bg-red-600 text-white text-xs font-bold px-3 py-1 uppercase rounded-sm shadow-md">
                                                {paper.edition}
                                            </div>
                                        </div>

                                        {/* Info Section */}
                                        <div className="p-5 flex-grow flex flex-col justify-between">
                                            <div>
                                                <h3 className="text-lg font-bold text-gray-800 line-clamp-2 leading-tight group-hover:text-blue-600 transition-colors">
                                                    {paper.title}
                                                </h3>
                                                <p className="text-gray-500 text-sm mt-2 font-medium">
                                                    {new Date(paper.publish_date).toLocaleDateString("en-IN", {
                                                        year: "numeric",
                                                        month: "long",
                                                        day: "numeric",
                                                    })}
                                                </p>
                                            </div>

                                            <div className="mt-4 pt-4 border-t flex justify-between items-center">
                                                <span className="text-blue-600 text-sm font-semibold flex items-center">
                                                    Read Now
                                                    <svg
                                                        className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                                    </svg>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Ad Section - 25% width on large screens */}
                    <div className="w-full lg:w-1/4">
                        <div className="sticky top-6 flex flex-col gap-6">

                            <h3 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-2 border-b pb-2">
                                Advertisement
                            </h3>

                            {ads.length === 0 ? (
                                <div className="bg-gray-100 border border-gray-200 border-dashed rounded-lg p-8 text-center text-gray-400 text-sm">
                                    Ad Space Available
                                </div>
                            ) : (
                                ads.map((ad) => (
                                    <div
                                        key={ad.id}
                                        className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden hover:shadow-lg transition"
                                    >

                                        {/* Ad Image */}
                                        <img
                                            // src={`${process.env.REACT_APP_API_URL}/ads/${ad.image_path}`}
                                            src={`${process.env.REACT_APP_API_URL}/ads/image/${ad.id}`}
                                            alt={ad.title}
                                            className="w-full h-40 object-cover"
                                        />

                                        {/* Ad Content */}
                                        <div className="p-4">

                                            <h4 className="font-semibold text-gray-800 text-sm mb-2">
                                                {ad.title}
                                            </h4>

                                            {ad.description && (
                                                <p className="text-gray-600 text-xs mb-3">
                                                    {ad.description}
                                                </p>
                                            )}

                                            {/* Learn More Button */}
                                            {ad.link_url && (
                                                <a
                                                    href={ad.link_url}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="text-blue-600 text-sm font-medium hover:underline"
                                                >
                                                    Learn more →
                                                </a>
                                            )}

                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;